// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".component-add-team-form__upper[data-v-baea4190]{display:flex}.component-add-team-form__upper__inputs[data-v-baea4190]{flex:1 1 auto}.component-add-team-form__upper__image[data-v-baea4190]{margin-left:1.5rem;margin-top:2rem;flex:0 0 auto;width:175px;height:175px}", ""]);
// Exports
module.exports = exports;
